// Гарантирует, что SDK CloudPayments (window.cp.CloudPayments) реально
// загружен, прежде чем его использовать.
//
// Раньше скрипт подключался через <script> внутри <Helmet> в App.jsx -
// на каждой странице, независимо от того, нужен ли он там. Тег script
// не блокирует рендер и не гарантирует, что скрипт успеет загрузиться до
// первого клика пользователя (медленная сеть, отсутствие в кэше при
// первом визите, или просто быстрый пользователь) - тогда
// window.cp.CloudPayments оказывается undefined, и обращение к нему
// падает с TypeError, роняя всю страницу через ErrorBoundary.
//
// Здесь скрипт грузится ПО ТРЕБОВАНИЮ (только когда реально нужен виджет
// оплаты, не на каждой странице) и вызывающий код может дождаться
// готовности перед тем, как создавать виджет.
let loadPromise = null;

export function loadCloudPayments() {
  if (window.cp?.CloudPayments) {
    return Promise.resolve(window.cp.CloudPayments);
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
    script.async = true;
    script.onload = () => {
      if (window.cp?.CloudPayments) {
        resolve(window.cp.CloudPayments);
      } else {
        loadPromise = null;
        reject(
          new Error(
            'CloudPayments SDK загрузился, но window.cp.CloudPayments не определён'
          )
        );
      }
    };
    script.onerror = () => {
      loadPromise = null; // даём возможность повторить попытку позже
      reject(new Error('Не удалось загрузить CloudPayments SDK'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
